export const testTimezone = [
  { id: 1, zone: "Asia/Tokyo", name: "日本" },
  { id: 2, zone: "UTC", name: "協定世界時" },
];
